import { createRouter, createWebHashHistory } from 'vue-router';
import Dashboard from '../views/Dashboard';
import Level from '../views/Level';
import Summary from '../views/GameSummary';

const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard,
  },
  {
    path: '/level',
    name: 'Level',
    component: Level,
  },
  {
    path: '/summary',
    name: 'Summary',
    component: Summary,
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
